<template>
  <!-- 底部 -->
  <div class="Fortherecords">
    <div class="background">
      <div class="background-one">
        <div class="Course-navigation">
          <div class="navigation">
            <ul>
              <li @click="homes('首页')">首页</li>
              <li @click="homes('在线课程')">在线课程</li>
              <!-- <li  @click="homes('热度排行')">热度排行</li> -->
              <li @click="homes('素材下载')">素材下载</li>
              <li @click="homes('关于我们')">关于我们</li>
              <!-- <li>在线课程</li> -->
            </ul>
            <ul style="margin-left: 51px">
              <!-- <li  @click="homes('关于我们')">关于我们</li> -->
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
          <div class="The-divider"></div>
          <div class="contact-manager">
            <div class="imgs-qr">
              <!-- <img src="../assets/qrcode.png" alt="" /> -->
              <img
                style="width: 117px; height: 117px"
                src="../assets/rcode.png"
                alt=""
              />
              <span>扫码添加</span>
            </div>
            <ul style="margin-top: -10px">
              <li>
                <img
                  style="width: 22px; height: 22px"
                  src="../assets/Contact-phone-number.png"
                  alt=""
                />
                <p>联系人: 金老师</p>
              </li>
              <li>
                <img
                  style="width: 20px; height: 20px; padding-top: 2px"
                  src="../assets/sj.png"
                  alt=""
                />
                <p>手机: 157-1135-5741</p>
              </li>
              <li>
                <img
                  style="width: 20px; height: 20px; padding-top: 2px"
                  src="../assets/number-number.png"
                  alt=""
                />
                <p>电话: 010-62906806</p>
              </li>
              <li>
                <img
                  style="width: 19px; height: 15px; padding-top: 5px"
                  src="../assets/Email-address.png"
                  alt=""
                />
                <p>邮箱: mukefuxue@163.com</p>
              </li>
              <li>
                <img
                  style="width: 19px; height: 19px; padding-top: 3px"
                  src="../assets/Address-now.png"
                  alt=""
                />
                <p>地址: 北京市海淀区清河街道清河嘉园西区</p>
              </li>
            </ul>
          </div>
          <div class="Cooperation-intention">
            <h4>课程合作</h4>
            <p>我们会在24小时内联系您</p>
            <input type="text" placeholder="请输入姓名" v-model="etces" />
            <input
              type="text"
              placeholder="请输入联系方式"
              style="margin-top: 10px"
              v-model="phone"
            />
            <!-- <div @click="inskczid()">提交</div> -->

            <el-button
              type="primary"
              @click="inskczid()"
              class="submit"
              v-preventReClick="3000"
              >提交</el-button
            >
          </div>
        </div>
      </div>
      <div class="Fortherecord">
        <!-- Copyright ©2018 北京蔚来高科技术有限公司 -->
        <!-- <span class="bjwlgk"
          ><a href="http://www.bjwlgk.com/"> （www.bjwlgk.com）</a>
        </span> -->
        版权所有 | ICP经营许可证:
        <span class="bjwlgks">
          <a href="https://beian.miit.gov.cn/"> 京ICP备18061172号-4 </a>
        </span>
      </div>
      <div class="Fortherecord1">
        Copyright ©2018 <br />
        北京蔚来高科技术有限公司<br />
        <span class="bjwlgk"
          ><a href="http://www.bjwlgk.com/"> （www.bjwlgk.com）</a> </span
        ><br />
        版权所有 | ICP经营许可证:<br />
        <span class="bjwlgks">
          <a href="https://beian.miit.gov.cn/"> 京ICP备18061172号-4 </a>
        </span>
      </div>
      <div class="mtop" ref="top" @click="goTop">
        <i class="el-icon-caret-top"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { inskcz } from "../api/patient";
export default {
  data() {
    return {
      etces: "",
      phone: "",
    };
  },
  methods: {
    homes(item) {
      if (item === "首页") {
        if (this.$route.path !== "/Home") {
          this.$router.push("/Home");
        } else {
          this.goTop();
        }
      }
      if (item === "在线课程" && this.$route.path !== "/myinformation") {
        this.$router.push("/myinformation");
      } else {
        this.goTop();
      }
      if (item === "热度排行" && this.$route.path !== "/ropularity") {
        this.$router.push("/ropularity");
      } else {
        this.goTop();
      }
      if (item === "素材下载" && this.$route.path !== "/materialpage") {
        this.$router.push("/materialpage");
      } else {
        this.goTop();
      }
      if (item === "关于我们" && this.$route.path !== "/aboutus") {
        this.$router.push("/aboutus");
      } else {
        this.goTop();
      }
    },
    // 联系方式
    inskczid() {
      var ss = this.phone;
      var a = ss.split("");
      if (a.length === 11 && this.etces !== "") {
        var data = new FormData();
        data.append("phone", this.phone);
        data.append("name", this.etces);
        data.append("hznr", "底部课程合作 不用留言");
        inskcz(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.phone = "";
            this.etces = "";
          }
        });
      } else {
        if (this.etces === "") {
          this.$message({
            showClose: true,
            message: "请填写完整",
            type: "warning",
          });
        } else if (a.lengt !== 11) {
          this.$message({
            showClose: true,
            message: "请填写正确手机号码",
            type: "warning",
          });
        }
      }
    },
    // 返回顶部
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.background {
  white-space: nowrap;
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 335px;
  background: url("../assets/background1.png");
  background-size: 100% 100%;
  z-index: 9999;
  .background-one {
    width: 1190px;
    display: flex;
    margin: 0 auto;
    .Course-navigation {
      width: 100%;
      padding-left: 50px;
      padding-right: 50px;
      padding-top: 55px;
      display: flex;
      .navigation {
        display: flex;
        //  margin-top: 50px;
        ul {
          height: 167px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 38px;
          li {
            display: flex;
            cursor: pointer;
          }
        }
      }
      .The-divider {
        width: 1px;
        height: 164px;
        // background: #999999;
        margin-left: 50px;
        // margin-top: 56px;
      }
      .contact-manager {
        margin-left: 43px;
        display: flex;
        .imgs-qr {
          display: flex;
          flex-direction: column;
          span {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #cccccc;
            margin-top: 14px;
          }
        }
        ul {
          margin-left: 38px;
          li {
            height: 22px;
            display: flex;
            margin-bottom: 27px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #d6d6d6;
            // line-height: 46px;
            img {
              line-height: 22px;
            }
            p {
              margin-left: 19px;
            }
          }
        }
      }
      .Cooperation-intention {
        // margin-top: 58px;
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-left: 47px;
        h4 {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #f0f0f0;
        }
        p {
          margin-top: 4px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          margin-bottom: 16px;
        }
        input::-webkit-input-placeholder,
        textarea::-webkit-input-placeholder {
          // color: rgba(153,153,153,0.2);
          color: #999;
        }
        input {
          width: 227px;
          height: 40px;
          padding-left: 15px;
          // background: #999999;
          background: rgba(153, 153, 153, 0.4);
          border-radius: 6px;
          // color: #999999;
          color: #fff;
        }
        .submit {
          padding: 0px;
          width: 60px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          // margin-left: 20px;
          margin-top: 11px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #fff;
          background: #909399;
          border-radius: 5px;

          cursor: pointer; //悬浮时变手指
        }
        .el-button--primary {
          border-color: #909399;
          border-color: "#909399";
        }
      }
    }
  }
}
.Fortherecord {
  // display: flex;
  margin-top: 25px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #d6d6d6;
}
.Fortherecord1 {
  display: none;
}
.mtop {
  i {
    width: 72px;
    height: 72px;
    position: fixed;
    right: 30px;
    bottom: 60px;
    border: 1px solid #ccc;
    border-radius: 50%;
    font-size: 36px;
    color: #4ccaff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  i:hover {
    color: #fff;
    background-color: #4accff;
  }
}
.bjwlgk {
  color: #4ccaff;
  cursor: pointer;
  a {
    color: #4ccaff;
  }
}
.bjwlgks {
  color: #fff;
  cursor: pointer;
  a {
    color: #fff;
  }
}

@media (max-width: 768px) {
  .background {
    white-space: nowrap;
    display: flex;
    flex-direction: column;

    width: 100%;
    min-height: 209px;
    background: url("../assets/background1.png");
    background-size: 100% 100%;
    z-index: 9999;
    .background-one {
      width: 95vw;
      display: flex;
      margin: 0 auto;
      .Course-navigation {
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
        padding-top: 25px;
        display: flex;
        .navigation {
          display: none;
          //  margin-top: 50px;
          ul {
            height: 167px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            line-height: 38px;
            li {
              display: flex;
              cursor: pointer;
            }
          }
        }
        .The-divider {
          display: none;
          width: 1px;
          height: 164px;
          // background: #999999;
          margin-left: 0px;
          // margin-top: 56px;
        }
        .contact-manager {
          margin-left: 0px;
          display: flex;
          .imgs-qr {
            display: none;
            flex-direction: column;
            span {
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #cccccc;
              margin-top: 14px;
            }
          }
          ul {
            margin-left: 10px;
            li {
              height: 22px;
              display: flex;
              margin-bottom: 7px;
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #d6d6d6;
              // line-height: 46px;
              img {
                line-height: 22px;
              }
              p {
                margin-left: 19px;
              }
            }
          }
        }
        .Cooperation-intention {
          // margin-top: 58px;
          display: none;
          flex-direction: column;
          text-align: left;
          margin-left: 47px;
          h4 {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #f0f0f0;
          }
          p {
            margin-top: 4px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            margin-bottom: 16px;
          }
          input::-webkit-input-placeholder,
          textarea::-webkit-input-placeholder {
            // color: rgba(153,153,153,0.2);
            color: #999;
          }
          input {
            width: 227px;
            height: 40px;
            padding-left: 15px;
            // background: #999999;
            background: rgba(153, 153, 153, 0.4);
            border-radius: 6px;
            // color: #999999;
            color: #fff;
          }
          .submit {
            padding: 0px;
            width: 60px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            // margin-left: 20px;
            margin-top: 11px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #fff;
            background: #909399;
            border-radius: 5px;

            cursor: pointer; //悬浮时变手指
          }
          .el-button--primary {
            border-color: #909399;
            border-color: "#909399";
          }
        }
      }
    }
  }
  .Fortherecord {
    display: none;
    margin-top: 25px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #d6d6d6;
  }
  .Fortherecord1 {
    display: block;
    margin-top: 25px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #d6d6d6;
  }
  .mtop {
    i {
      right: 60px;
    }
  }
}
</style>
